import React, { useState } from 'react'
import ModalTest from '../../BaseModal'
import * as S from '../../styles/modal-style'
import { X } from 'lucide-react'
import axios from '../../../config/axios'
import { Step } from '../../../pages/ClientPanel/Pipelines/types'

interface PropsInterface {
  closeModal: () => void
  pipelineId: number

}

const AddStepInPipeline:React.FC<PropsInterface> = ({closeModal, pipelineId}) => {
  const [stepName, setStepName] = useState('')
  const [isSaving, setIsSaving] = useState(false)

  const handleSaveStep = async () => {
    const normalizedStepName = stepName.trim()
    if (!normalizedStepName || isSaving) {
      return
    }
    try {
      setIsSaving(true)
      const response = await axios.post(`${process.env.REACT_APP_GATEWAY_BASE_URL}/pipelines/step`, {
        name: normalizedStepName,
        pipelineId
      })
      if(response.data) {
        closeModal()
      }
    } catch(error) {
      console.error(error) 
    } finally {
      setIsSaving(false)
    }
  }
  
  return (
    <ModalTest>
      <S.ContainerOfModal>
      <S.Header>
        <S.HeaderTitle>Adicionar etapa</S.HeaderTitle>
          <S.CloseDiv onClick={() => closeModal()}>
            <X size={20} />
          </S.CloseDiv>
        </S.Header>
        <S.FormContainer
          onSubmit={(e) => {
            e.preventDefault()
            handleSaveStep()
          }}
        >
          <S.InputDiv>
            <S.Label>Nome da etapa</S.Label>
            <S.Input
              placeholder='Digite aqui...'
              autoFocus
              value={stepName}
              onChange={(e) => setStepName(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  e.preventDefault()
                  handleSaveStep()
                }
              }}
            />
          </S.InputDiv>
        </S.FormContainer>
        <S.BottomDiv>
          <S.ButtonContainer>
            <S.Button type='button' onClick={() => closeModal()} className='cancel'>Cancelar</S.Button>
            <S.Button type='button' onClick={() => handleSaveStep()} disabled={!stepName.trim() || isSaving}>Salvar</S.Button>
          </S.ButtonContainer>
        </S.BottomDiv>
      </S.ContainerOfModal>
    </ModalTest>
  )
}

export default AddStepInPipeline